import { i18n } from '@/plugins/i18n';
import rsHolding from './rs-holding.json';

export const RS_HOLDING_COMPANY_ID = 1118;

/**
 * Per-company wording overrides, keyed by company id. Each entry maps a locale
 * to a partial message tree that is merged over the shared lang files, so only
 * the listed keys change and everything else falls back to lang/<locale>.json.
 */
const COMPANY_LABEL_OVERRIDES = {
	[RS_HOLDING_COMPANY_ID]: rsHolding,
};

/**
 * Merges the wording overrides of the given company into the active i18n
 * messages. No-op for companies without overrides.
 *
 * @param {number} companyId
 */
export const applyCompanyLabelOverrides = companyId => {
	const overrides = COMPANY_LABEL_OVERRIDES[companyId];

	if (!overrides) {
		return;
	}

	Object.keys(overrides).forEach(locale => {
		i18n.mergeLocaleMessage(locale, overrides[locale]);
	});
};
